'use strict';

const updateUsedDispositionCodes = (state, dispositionCode) => {
  const index = state.mostUsed.findIndex(item => item.id === dispositionCode.id);

  if (index >= 0) {
    state.mostUsed[index].usages += 1;
  } else {
    state.mostUsed.push({ ...dispositionCode, usages: 1 });
  }
};

export default {
  updateUsedDispositionCodes
};
